/**
 * Widget Components Index
 * Maps widget IDs to their React components
 */

// Hub widgets
import StateCardsWidget from './StateCardsWidget';
import TodaysFocusWidget from './TodaysFocusWidget';
import AskMabelWidget from './AskMabelWidget';
import TasksCardWidget from './TasksCardWidget';
import KitchenCardWidget from './KitchenCardWidget';
import MoneyCardWidget from './MoneyCardWidget';
import RoadmapCardWidget from './RoadmapCardWidget';
import RecentWinsWidget from './RecentWinsWidget';
import ReviewWidget from './ReviewWidget';
import InstallWidget from './InstallWidget';

// Kitchen dashboard card widgets
import TonightCardWidget from './TonightCardWidget';
import ExpiringCardWidget from './ExpiringCardWidget';
import ShoppingCardWidget from './ShoppingCardWidget';
import PantryCardWidget from './PantryCardWidget';
import MealsCardWidget from './MealsCardWidget';
import FoodLogCardWidget from './FoodLogCardWidget';

// Kitchen full widgets (for sub-views)
import PantryWidget from './PantryWidget';
import ShoppingWidget from './ShoppingWidget';
import MealsWidget from './MealsWidget';
import MealPlanWidget from './MealPlanWidget';
import FoodLogWidget from './FoodLogWidget';

/**
 * Map of widget ID to component
 * Used by WidgetGrid to render widgets dynamically
 */
export const WIDGET_COMPONENTS = {
  // Hub widgets
  stateCards: StateCardsWidget,
  todaysFocus: TodaysFocusWidget,
  askMabel: AskMabelWidget,
  tasksCard: TasksCardWidget,
  kitchenCard: KitchenCardWidget,
  moneyCard: MoneyCardWidget,
  roadmapCard: RoadmapCardWidget,
  recentWins: RecentWinsWidget,
  review: ReviewWidget,
  install: InstallWidget,
  
  // Kitchen dashboard cards
  tonightCard: TonightCardWidget,
  expiringCard: ExpiringCardWidget,
  shoppingCard: ShoppingCardWidget,
  pantryCard: PantryCardWidget,
  mealsCard: MealsCardWidget,
  foodLogCard: FoodLogCardWidget,
  
  // Kitchen full widgets (for sub-views and Hub cross-domain)
  pantry: PantryWidget,
  shopping: ShoppingWidget,
  meals: MealsWidget,
  mealPlan: MealPlanWidget,
  foodLog: FoodLogWidget,
  
  // Tasks domain widgets (to be added in Phase 2)
  // taskFilters: TaskFiltersWidget,
  // taskList: TaskListWidget,
};

// Alias for backwards compatibility
export const widgetComponents = WIDGET_COMPONENTS;

// Named exports for direct imports
export {
  // Hub
  StateCardsWidget,
  TodaysFocusWidget,
  AskMabelWidget,
  TasksCardWidget,
  KitchenCardWidget,
  MoneyCardWidget,
  RoadmapCardWidget,
  RecentWinsWidget,
  ReviewWidget,
  InstallWidget,
  // Kitchen cards
  TonightCardWidget,
  ExpiringCardWidget,
  ShoppingCardWidget,
  PantryCardWidget,
  MealsCardWidget,
  FoodLogCardWidget,
  // Kitchen full
  PantryWidget,
  ShoppingWidget,
  MealsWidget,
  MealPlanWidget,
  FoodLogWidget,
};

export default WIDGET_COMPONENTS;
